// Control data for OGFZA website

export const ASSETS = {
  logo: "/assets/images/logo.png",
  cover: "/assets/images/ogfza-cover.jpg",
  onne: "/assets/images/onne.jpg",
  notore: "/assets/images/notore.jpg",
  liberty: "/assets/images/liberty.jpg",
  brass: "/assets/images/brass.jpg",
  warri: "/assets/images/warri.jpg",
  ekoSupport: "/assets/images/eko-support.jpg",
  bestaf: "/assets/images/bestaf.jpg",
};

export const heroSlides = [
  {
    id: 1,
    kind: "image",
    image: ASSETS.cover,
    overlayText: "Oil & Gas Free Zones Authority",
    title: "Promoting Investment in Nigeria’s Oil & Gas Free Zones",
    subtitle:
      "OGFZA regulates, promotes, secures, and sustains investments across Nigeria’s oil and gas free zones.",
  },
  {
    id: 2,
    kind: "image",
    image: ASSETS.onne,
    overlayText: "World-Class Free Zone Regulation",
    title: "Driving Industrial Growth Through Free Zones",
    subtitle:
      "Supporting investors with incentives, efficient regulation, logistics access, and investor-friendly services.",
  },
  {
    id: 3,
    kind: "image",
    image: ASSETS.liberty,
    overlayText: "Investment • Regulation • Growth",
    title: "Nigeria’s Gateway to Oil & Gas Investment",
    subtitle:
      "Creating an enabling environment for local and international investors across the oil and gas value chain.",
  },
];

export const stats = [
  { id: 1, value: 7, label: "Oil & Gas Free Zones", icon: "building" },
  { id: 2, value: 200, label: "Licensed Companies", icon: "briefcase" },
  { id: 3, value: 45, label: "Nationalities Represented", icon: "globe" },
  { id: 4, value: 100000, label: "Direct & Indirect Jobs", icon: "users" },
];

export const objectives = [
  "Regulate and supervise operations of oil and gas free zones in Nigeria.",
  "Promote, secure, and sustain investments in Nigeria’s oil and gas free zones.",
  "Provide investor-friendly regulatory services and incentives.",
  "Facilitate public-private partnership investments in the oil and gas sector.",
  "Support industrial development, trade facilitation, logistics efficiency, and economic growth.",
];

export const philosophyText = [
  "The Oil & Gas Free Zones Authority is committed to building globally competitive free zones that attract investment, create jobs, and strengthen Nigeria’s position as a strategic oil and gas hub.",
  "OGFZA believes that free zones should provide investors with a predictable, transparent, efficient, and business-friendly operating environment.",
  "Through effective regulation, incentives, infrastructure support, and stakeholder collaboration, OGFZA works to make Nigeria’s oil and gas free zones first-choice destinations for investors.",
  "The Authority’s philosophy is built on integrity, professionalism, transparency, accountability, customer centricity, creativity, and respect.",
];

export const whatWeDo = [
  {
    id: 1,
    title: "Free Zone Regulation",
    description:
      "OGFZA regulates and supervises oil and gas free zones across Nigeria in line with its enabling Act and regulations.",
    icon: "shield-check",
  },
  {
    id: 2,
    title: "Investment Promotion",
    description:
      "The Authority promotes investment opportunities and supports investors across the oil and gas value chain.",
    icon: "trending-up",
  },
  {
    id: 3,
    title: "Licensing & Approvals",
    description:
      "OGFZA facilitates licence issuance, enterprise registration, renewals, approvals, permits, and compliance services.",
    icon: "file-check",
  },
];

export const services = [
  {
    id: 1,
    title: "Registration of Free Zone Enterprise",
    description:
      "Registration service for companies seeking to operate within Nigeria’s oil and gas free zones.",
    icon: "file-text",
  },
  {
    id: 2,
    title: "Renewal of Licence",
    description:
      "Licence renewal support for existing free zone enterprises, developers, and operators.",
    icon: "refresh-cw",
  },
  {
    id: 3,
    title: "Application for Licence",
    description:
      "Application processing for service licences, enterprise licences, developer licences, and special activity licences.",
    icon: "clipboard-check",
  },
  {
    id: 4,
    title: "Submission of Annual Returns",
    description:
      "Annual returns submission and compliance documentation for registered free zone entities.",
    icon: "calendar-check",
  },
  {
    id: 5,
    title: "HSE Service Charter",
    description:
      "Health, safety, and environmental compliance services, inspections, permits, and certification.",
    icon: "shield",
  },
  {
    id: 6,
    title: "Engineering & Projects",
    description:
      "Support for infrastructure, project development, technical review, and free zone engineering services.",
    icon: "hard-hat",
  },
];

export const projectsFaq = [
  {
    id: 1,
    q: "What is OGFZA?",
    a: "OGFZA means Oil & Gas Free Zones Authority. It is Nigeria’s national regulatory agency responsible for supervising oil and gas free zones.",
  },
  {
    id: 2,
    q: "Who can invest in OGFZA free zones?",
    a: "Companies operating in the oil and gas sector and its value chain can invest in OGFZA-regulated free zones.",
  },
  {
    id: 3,
    q: "How long does it take to acquire a free zone licence?",
    a: "OGFZA states that licences are issued within seven days after submission of all required documents and confirmation of prescribed fees.",
  },
];

export const projectsImages = [ASSETS.onne, ASSETS.notore, ASSETS.liberty];

export const boardMembers = [
  {
    id: 1,
    name: "Bamanga Usman Jada",
    role: "Managing Director / CEO",
    image: "/assets/images/md.jpg",
    bio:
      "Leads the Oil & Gas Free Zones Authority and drives the Authority’s strategic roadmap for investment, regulatory modernization, infrastructure excellence, and stakeholder confidence.",
  },
  {
    id: 2,
    name: "Simon Ovbe Akpadaka",
    role: "General Manager, Finance",
    image: "/assets/images/team-1.jpg",
    bio:
      "Oversees financial administration, accountability, budgeting, and financial operations of the Authority.",
  },
  {
    id: 3,
    name: "Adamu Mamman Kontagora",
    role: "General Manager, Trade and Investment",
    image: "/assets/images/team-2.jpg",
    bio:
      "Coordinates trade and investment promotion activities aimed at attracting investors into Nigeria’s oil and gas free zones.",
  },
  {
    id: 4,
    name: "Ivuoma Michael Okoro",
    role: "General Manager, Policy, Planning, Research & Statistics",
    image: "/assets/images/team-3.jpg",
    bio:
      "Leads policy planning, research, data analysis, and statistical reporting for strategic decision-making.",
  },
  {
    id: 5,
    name: "Cynthia Eguridu",
    role: "Chief Operating Officer, Freezone Global Investments Ltd",
    image: "/assets/images/team-4.jpg",
    bio:
      "Leads OGFZA’s investment subsidiary and supports public-private partnerships and investor engagement.",
  },
  {
    id: 6,
    name: "Igbiks Tamunoseipiriye, Esq.",
    role: "Head of Legal Services / Board Secretary",
    image: "/assets/images/team-5.jpg",
    bio:
      "Provides legal advisory services, regulatory guidance, and board secretarial support to the Authority.",
  },
];

export const chairman = {
  name: "Bamanga Usman Jada",
  title: "Managing Director / CEO, OGFZA",
  image: "/assets/images/md.jpg",
  message: [
    "The Oil & Gas Free Zones Authority is committed to aligning its operations with Nigeria’s economic development objectives.",
    "Our goal is to reposition Nigeria’s oil and gas free zones as first-choice destinations for investors through efficiency, transparency, infrastructure excellence, and regulatory modernization.",
    "We are focused on promoting investment, improving service delivery, empowering local content, strengthening sustainability, and improving staff welfare.",
    "OGFZA will continue to work with stakeholders, investors, developers, and government institutions to create an enabling business environment for accelerated growth.",
  ],
};

export const navigation = [
  {
    label: "Home",
    path: "/",
    children: [],
  },
  {
    label: "About Us",
    path: "/about",
    children: [
      { label: "Vision / Mission / Mandate", path: "/about/vision-mission-mandate" },
      { label: "OGFZA History", path: "/about/history" },
      { label: "Track Record", path: "/about/track-record" },
      { label: "Why OGFZ", path: "/about/why-ogfz" },
      { label: "Management Team", path: "/about/management-team" },
      { label: "OGFZA Organogram", path: "/about/organogram" },
      { label: "Legal", path: "/about/legal" },
      { label: "MD’s Message", path: "/about/md-message" },
      { label: "Incentives", path: "/about/incentives" },
      { label: "Client Overview", path: "/about/client-overview" },
    ],
  },
  {
    label: "The SPV",
    path: "/spv",
    children: [
      { label: "About SPV", path: "/spv/about" },
      {
        label: "Contact SPV",
        path: "https://fzgil.org/",
        external: true,
      },
    ],
  },
  {
    label: "Free Zones",
    path: "/free-zones",
    children: [
      {
        label: "Onne",
        path: "/free-zones/onne",
        children: [
          { label: "Notore Industrial City", path: "/free-zones/notore-industrial-city" },
          { label: "Brawal", path: "/free-zones/brawal" },
        ],
      },
      { label: "BESTAF", path: "/free-zones/bestaf" },
      { label: "Eko Support", path: "/free-zones/eko-support" },
      {
        label: "Liberty",
        path: "/free-zones/liberty",
        children: [{ label: "SPFL-FZE", path: "/free-zones/spfl-fze" }],
      },
      { label: "Brass", path: "/free-zones/brass" },
      { label: "Warri", path: "/free-zones/warri" },
      { label: "Secured Bunkering Anchorage (SBA)", path: "/free-zones/sba" },
      { label: "Orashi Special Energy", path: "/free-zones/orashi-special-energy" },
    ],
  },
{
  label: "Services",
  path: "/services",
  children: [
    {
      label: "Registry",
      path: "/services/registry",
    },
    {
      label: "Engineering",
      path: "/services/engineering",
    },
    {
      label: "HSE",
      path: "/services/hse",
    },
    {
      label: "Operations",
      path: "/services/operations",
    },
  ],
},

  {
    label: "FZEs",
    path: "https://ogfza.gov.ng/enterprises",
    external: true,
    children: [],
  },
  {
    label: "Publications",
    path: "/publications",
    children: [
      { label: "OGFZA News", path: "/publications/news" },
      { label: "Announcement", path: "/publications/announcement" },
      { label: "Newsletters", path: "/publications/newsletters" },
      { label: "OGFZA Download", path: "/publications/ogfza-download" },
      {
        label: "Ease of Business – Service Charter",
        path: "/publications/ease-of-business-service-charter",
      },
      { label: "Media Gallery", path: "/publications/media-gallery" },
    ],
  },
  {
    label: "Download",
    path: "/downloads",
    children: [
      { label: "OGFZA ACT 1996", path: "/downloads/ogfza-act-1996" },
      { label: "OGFZA Regulations 2019", path: "/downloads/ogfza-regulations-2019" },
      { label: "Free Zone Application Form", path: "/downloads/free-zone-application-form" },
      {
        label: "Memo and Articles of Association",
        path: "/downloads/memo-and-articles-of-association",
      },
      { label: "Particulars of Directors", path: "/downloads/particulars-of-directors" },
      { label: "Statement of Share Capital", path: "/downloads/statement-of-share-capital" },
      { label: "OGFZA BOI Disclosure Form", path: "/downloads/boi-disclosure-form" },
      {
        label: "OGFZA Disclosure of Beneficial Owners Regulation",
        path: "/downloads/beneficial-owners-regulation",
      },
      { label: "Client List – Download", path: "/downloads/client-list" },
    ],
  },
  {
    label: "Contact/Help",
    path: "/contact-help",
    children: [
      { label: "FAQ", path: "/contact-help/faq" },
      { label: "Client Service Lines", path: "/contact-help/client-service-lines" },
      { label: "Customer Service: (contact@ogfza.gov.ng)", path: "/contact-help/customer-service" },
      { label: "Submit Regulatory Complaint", path: "/contact-help/complaints" },
      { label: "Track Complaint", path: "/contact-help/track-complaint" },
      { label: "Complaint Data Bank", path: "/contact-help/complaint-data-bank" },
    ],
  },
];

export const footerInfo = {
  address:
    "Oil & Gas Free Zones Authority (OGFZA), Marble House, Federal Ocean Terminal, Onne Port Complex, Rivers State, Nigeria.",
  offices: [
    {
      title: "Head Office",
      address: "PMB 5474, Onne Port Complex, Rivers State, Nigeria",
      phone: "+234-909-111-1184",
      hours: "Mon - Fri 09:00am - 05:00pm",
    },
    {
      title: "Lagos Regional Office",
      address: "No 169b Moshood Olugbani Street, Victoria Island, Lagos",
      phone: "+234-909-111-1185",
      hours: "Mon - Fri 09:00am - 05:00pm",
    },
    {
      title: "Abuja Liaison Office",
      address: "#4 Pop John Paul Street, off Gana Street, Maitama, Abuja",
      phone: "+234-909-111-1185",
      hours: "Mon - Fri 09:00am - 05:00pm",
    },
    {
      title: "Warri Office",
      address: "Oil & Gas Free Zone Warri Port Complex, Delta State",
      phone: "+234-909-111-1185",
      hours: "Mon - Fri 09:00am - 05:00pm",
    },
  ],
  emails: ["contact@ogfza.gov.ng"],
  phones: ["+234-909-111-1184", "+234-909-111-1185"],
};